var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBillingLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.03,
    height: 16.821,
    viewBox: "0 0 24.03 16.821",
    opacity: 1,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "money-bills-solid",
    d: "M3.6,34.4a2.4,2.4,0,0,1,2.4-2.4H21.627a2.4,2.4,0,0,1,2.4,2.4v8.41a2.4,2.4,0,0,1-2.4,2.4H6.007a2.4,2.4,0,0,1-2.4-2.4Zm2.4,8.41h2.4a2.4,2.4,0,0,0-2.4-2.4Zm0-8.41v2.4a2.4,2.4,0,0,0,2.4-2.4ZM21.627,40.41a2.4,2.4,0,0,0-2.4,2.4h2.4Zm-2.4-6.007a2.4,2.4,0,0,0,2.4,2.4V34.4Zm-5.407,1.2a3,3,0,1,0,3,3A3,3,0,0,0,13.817,35.6ZM1.8,44.315a2.7,2.7,0,0,0,2.7,2.7H19.524a.9.9,0,1,1,0,1.8H4.506A4.505,4.505,0,0,1,0,44.315V35.3a.9.9,0,0,1,1.8,0Z",
    transform: "translate(0 -32)",
    fill: "#23b574"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBillingLogo);
export default __webpack_public_path__ + "static/media/billing-logo.468770c65dd6eee3c4cc2e465d494ed7.svg";
export { ForwardRef as ReactComponent };